/**
 * FIELD RELIABILITY — the running build's identity string.
 *
 * `__APP_VERSION__` / `__BUILD_SHA__` are compile-time constants injected
 * by the `define` block in vite.config.ts. Vitest (and any non-Vite
 * runtime) doesn't perform that substitution, so both reads are guarded —
 * tests and dev tools see "dev" instead of a ReferenceError.
 *
 * Shown in tiny text on the field job list footer so the office can ask a
 * tech "what version does your footer say?" and pin the exact build a
 * misbehaving iPad is actually running.
 */
export function appVersion(): string {
    const version = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";
    const sha = typeof __BUILD_SHA__ !== "undefined" ? __BUILD_SHA__ : "";
    return sha ? `v${version} (${sha})` : `v${version}`;
}
